export default __webpack_public_path__ + "static/media/rewardInfo.9e4d5c61.png";